export default "__VITE_ASSET__fd38a8ee__"